import { useState, useRef } from "react";
import useApiActions from "../../../hooks/api-actions.hook";

const useGetToolProducts = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const { getPagedPackageProduct } = useApiActions();
  const callCounter = useRef(0);

  const fetchProducts = async ({ pageNumber, searchValue }) => {
    const currentCall = ++callCounter.current;
    setIsLoading(true);
    try {
      const response = await getPagedPackageProduct({ pageNumber, searchValue });
      if (currentCall === callCounter.current) {
        if (pageNumber !== 0) {
          setData(prevData => ({
            ...response,
            PSAProductVM_List: [...(prevData?.PSAProductVM_List || []), ...response.PSAProductVM_List]
          }));
        } else {
          setData(response);
        }
      }
    } catch (error) {
      console.error("Error fetching tool products", error);
    } finally {
      if (currentCall === callCounter.current) {
        setIsLoading(false);
      }
    }
  }

  return { isLoading, data, fetchProducts };
}

export default useGetToolProducts;
